import { render, staticRenderFns } from "./ZhunBei.vue?vue&type=template&id=5f4864d1&scoped=true&"
import script from "./ZhunBei.vue?vue&type=script&lang=js&"
export * from "./ZhunBei.vue?vue&type=script&lang=js&"
import style0 from "./ZhunBei.vue?vue&type=style&index=0&id=5f4864d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4864d1",
  null
  
)

export default component.exports